import { Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { setItem } from "../../../utils/localStorage";
import { useContext } from "react";
import { StatusCodes } from "http-status-codes";
import { LoggedInUserContext } from "../../../context/loggedInUserContext";
import { LoginUser } from "../../../services/auth.service";
import { toast } from "react-toastify";
import FormikInput from "../../../components/FormikFieldCustom";
import ButtonLoader from "../../../components/ButtonLoader";
import { Roles } from "../../../types/role.enums";
import { loginValidationSchema } from "../../../utils/validations";
const Login = () => {
  const navigate = useNavigate();
  const { setLoggedInUserContext } = useContext(LoggedInUserContext);
  return (
    <div>
      <h3 className="text-center">Auctioner/Admin Login</h3>
      <Formik
        onSubmit={async (values, { setSubmitting }) => {
          //call login API
          setSubmitting(true);
          const response: any = await LoginUser(values);
          if (response.status_code === StatusCodes.OK && response.status) {
            if (response.data.role.name === Roles.SUPER_ADMIN) {
              navigate("/admin");
            }
            setLoggedInUserContext(response.data);
            setItem("user", response.data);
            toast.success("Logged in successfully");
          } else {
            toast.error(response.message);
          }
          setSubmitting(false);
        }}
        initialValues={{ email: "", password: "" }}
        validationSchema={loginValidationSchema}
      >
        {({ isSubmitting }) => (
          <Form>
            <div className="flex flex-col border-2 p-2 gap-2 border-gray-400">
              <FormikInput name="email" label="Email" />
              <FormikInput type="password" name="password" label="Password" />
              <div className="flex items-center">
                <label
                  className="text-xs text-gray-500 cursor-pointer"
                  onClick={() => navigate("/forgot-password")}
                >
                  Forgot password?
                </label>
                &nbsp;
                <button
                  type="submit"
                  className="border-2 px-1 border-gray-600 bg-gray-400"
                >
                  {isSubmitting ? (
                    <>
                      <ButtonLoader />
                      Loading...
                    </>
                  ) : (
                    "Login"
                  )}
                </button>
              </div>
            </div>
            <div className="mt-2 p-2 border-2 border-gray-400 flex items-center justify-center flex-col">
              <p className="text-center">Don't have an auctioner account?</p>
              <button
                className="border-2 px-1 border-gray-600 bg-gray-400"
                onClick={() => navigate("/signup")}
              >
                Register
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Login;
